import React, { useEffect, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import { Link } from "react-router-dom";
import Loading from "../Hooks/Loading";
import axios from "../Hooks/axios";
import styles from "./Suggestion.module.scss";
import UserBox from "./UserBox";

const PostSuggestion2 = () => {
	console.log("PostSuggestion render");
	const [userData, setUserData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		console.log("API calling...");

		setIsLoading(true);

		axios
			.get(`/auth/randomUser`)
			.then(({ data }) => {
				console.log("DATA =>", data);

				setUserData(data || []);
				setIsLoading(false);
			})
			.catch((error) => {
				console.log("Error => ", error);

				setIsLoading(false);
			});
	}, []);

	return (
		<div className={styles.Suggestion}>
			<div className={styles.SuggestionText}>
				<h1>Suggested for you</h1>

				{/* <Link>See all</Link> */}
			</div>

			<div className={styles.OuterWrapper}>
				{isLoading ? (
					<Loading />
				) : (
					<div className={styles.UserList}>
						{userData.map((data, index) => (
							<UserBox key={index} data={data} />
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default PostSuggestion2;


